// Centralised dashboard IDs file
// Replace placeholder values with your actual Superset dashboard IDs (strings or numbers as required).

// Main dashboards
export const main_dashboard_id = 'REPLACE_MAIN_DASHBOARD_ID';
export const erica_dashboard_id = 'fdc641dd-553f-4283-a560-b99bf5ceb0cc';
export const lesedi_dashboard_id = 'c9d9f4e2-0c04-4e62-8c01-4af5028054c4';
export const thembokwezi_dashboard_id = 'cca464d4-a0c0-4ed8-ab91-7d27f0023558';
export const ekuphumleni_dashboard_id = '35c60269-4af4-4065-b07c-2a849fa2e852';
export const ganyesa_dashboard_id = 'bbd6f78b-82bf-4c04-a93b-4b81126f515a';
export const amsterdam_dashboard_id = 'REPLACE_AMSTERDAM_DASHBOARD_ID';
export const madadeni_dashboard_id = 'REPLACE_MADADENI_DASHBOARD_ID';
export const aliwal_north_dashboard_id = 'REPLACE_ALIWAL_NORTH_DASHBOARD_ID';
export const rustenburg_dashboard_id = 'REPLACE_RUSTENBURG_DASHBOARD_ID';
export const ngqamakhwe_dashboard_id = 'REPLACE_NGQAMAKHWE_DASHBOARD_ID';
export const mkhondo_dashboard_id = 'REPLACE_MKHONDO_DASHBOARD_ID';

// Global dashboards
export const global_executive_dashboard_id = '295fb3f6-dd32-4d51-82b3-7b4914bab3d8';
export const global_financial_dashboard_id = '2c63353b-bd72-41e8-b14e-98685a218f45';
export const global_comparisons_dashboard_id = 'be779bf9-ba8c-4a86-bc16-f817081882c3';
export const global_esg_dashboard_id = '4a745570-a047-443c-ac3e-7fad4f1f8765';
export const global_fungi_profit_share_id = 'dc438096-2de8-4311-8538-e389ab92967d';
export const global_risk_intelligence_dashboard_id = '2756d51d-3bad-4b6a-bcd9-1379c45825ec';
export const global_turnover_dashboard_id = '5112bd38-0d94-4b7e-a115-651ef00c2ed7';

// Mining dashboards, keyed by mining sidebar menu item (see `data/mining.js`)
export const mining_dashboards = {
  'command-centre': '768eae6f-ca36-462d-a9f5-8906de445900',
  'shift-control': '46a316a2-fbf6-4e1d-95d0-efb540f592ef'
};

// Property-level universal dashboards (fallbacks)
export const property_parking_dashboard_id = 'REPLACE_PROPERTY_PARKING_DASHBOARD_ID';
export const property_operations_dashboard_id = 'REPLACE_PROPERTY_OPERATIONS_DASHBOARD_ID';
export const property_security_dashboard_id = 'REPLACE_PROPERTY_SECURITY_DASHBOARD_ID';
export const property_analytics_dashboard_id = 'REPLACE_PROPERTY_ANALYTICS_DASHBOARD_ID';
export const property_utilities_dashboard_id = 'REPLACE_PROPERTY_UTILITIES_DASHBOARD_ID';
export const property_resources_dashboard_id = 'REPLACE_PROPERTY_RESOURCES_DASHBOARD_ID';
export const property_savings_insights_dashboard_id = '92de10ae-f793-4445-a2d4-0cf45adfe4a7';

// Property-specific dashboards (per-property overrides)
// Keep the same keys used by `dashboard_one.js` for automatic compatibility.
export const property_specific_dashboards = {
  'AI Campus': {
    'operations-overview': '607df237-6632-4039-a82c-00a27fd7bc84',
    'utilities': '1c25d0d5-abd2-4db7-abee-3a657854241e',
    'energy': 'baa0bd11-4100-4952-afe0-e552e64d739e',
    'savings_insights': '6365dade-d4d5-49d0-bd82-3df0a18b4452',
    'security': '471124f9-b62b-4e16-9ec8-9d29d89c5110',
    'connectivity': '8c98359a-54f3-4343-a697-7edc3a53bef7',
    'insights-analytics': '09d0977c-adb9-4d1c-80a6-fb0747dba9de'
  },

  'Lesedi City Shopping Centre': {
    'executive-summary': lesedi_dashboard_id,
    'operations-overview': '9063931c-59cd-4acb-b734-dcda26e73b66',
    'utilities': '44f2f9d0-00b2-4c33-ae6d-22758ce73521',
    'energy': '0e7f85ca-92a9-43c8-9609-f06a576be5c4',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': '66e3783b-056a-4d8e-939e-37e97da47698',
    'connectivity': '0a36e130-3286-438f-a1f8-18851ff08c8a',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': '92de10ae-f793-4445-a2d4-0cf45adfe4a7',
    'profit-share': 'b2d9f43d-0c2b-4a01-8703-88d173410a9b',
    'resources': 'REPLACE_LESEDI_RESOURCES_DASHBOARD_ID'
  },

  'Ekuphumleni Retail Centre': {
    'executive-summary': ekuphumleni_dashboard_id,
    'operations-overview': '3b96defa-1471-4876-96e5-9f92725a7737',
    'utilities': 'e08ccee5-187d-4299-b39f-58d722392f9b',
    'energy': '0da05cfe-037f-448c-aa85-baa1a07b2bd4',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': '1ed0508e-7ece-486c-a0e0-42b0eb68c19e',
    'connectivity': '2d762e8c-7201-4204-8bf5-dd961f122b6a',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': '92de10ae-f793-4445-a2d4-0cf45adfe4a7',
    'profit-share': '6ddcf690-4d62-4f8d-9ff5-c239ffef666c',
    'resources': 'REPLACE_EKUPHUMLENI_RESOURCES_DASHBOARD_ID'
  },

  'Ganyesa': {
    'executive-summary': ganyesa_dashboard_id,
    'operations-overview': '80e4d954-3228-4af1-8ed1-91bf75a08a58',
    'utilities': 'e0033816-4a0f-489f-9fad-b8c43facc75a',
    'energy': '6ef4e8c7-d3ff-44bb-8021-50be9da807f2',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': 'ae4a1b07-c0f2-4c62-91da-184fb77d9c02',
    'connectivity': '0de81416-9bfa-4d03-b00e-201dfcc16bc7',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': '92de10ae-f793-4445-a2d4-0cf45adfe4a7',
    'profit-share': 'dee9b071-20b7-4625-9744-0e9b0f745e9d',
    'resources': 'REPLACE_GANYESA_RESOURCES_DASHBOARD_ID'
  },

  'Erica Square': {
    'executive-summary': erica_dashboard_id,
    'operations-overview': 'c6ed6acf-6c78-4773-8273-7359da6b661a',
    'utilities': 'cd841539-17bb-4241-aa15-57237527c6d0',
    'energy': 'f77568b9-9ab3-47eb-82ed-241b9a9e5ff0',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': 'ad7bdeef-4eef-4230-8b9a-69bba1ccdf7d',
    'connectivity': 'bf1c1746-da9c-45af-8a6b-4a7381ea7887',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': '92de10ae-f793-4445-a2d4-0cf45adfe4a7',
    'profit-share': '67647084-bcb3-446e-9ed9-2a9ba2246ff3',
    'resources': 'REPLACE_ERICA_RESOURCES_DASHBOARD_ID'
  },

  'Thembokwezi Square': {
    'executive-summary': thembokwezi_dashboard_id,
    'operations-overview': '3902b4ed-98df-43ac-8a2f-6857cd6d79f3',
    'utilities': '5f6618b3-1363-4400-9c80-91d350916dd1',
    'energy': '3449501b-c48f-4734-ab81-c386bd258542',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': '482f5452-fafc-4128-9550-203d9953d4c0',
    'connectivity': '863ca75d-ce8b-4b9f-9433-d56e5b43ca65',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': '92de10ae-f793-4445-a2d4-0cf45adfe4a7',
    'profit-share': '85fd70e5-850e-4d45-bfcb-7cd0c01a6b05',
    'resources': 'REPLACE_THEMBOKWEZI_RESOURCES_DASHBOARD_ID'
  },

  'Amsterdam': {
    'executive-summary': amsterdam_dashboard_id,
    'operations-overview': 'd250fa22-7a29-4982-81a7-83a9e18bce37',
    'utilities': 'e04bc6f7-656e-463a-be27-bd328f7be33f',
    'energy': '9e62f56a-115b-4c76-96ba-d840ffc74260',
    'parking-access': 'REPLACE_AMSTERDAM_PARKING_DASHBOARD_ID',
    'security': '62993188-3961-4725-831b-df25db80a58e',
    'connectivity': 'b25b80eb-d198-4c40-bcba-7bdff2f7243d',
    'insights-analytics': '59504596-89cc-4743-92ac-38130d3e4ffd',
    'savings_insights': 'f8bbcc65-2ea7-4749-a975-f84252cb8628',
    'profit-share': '2ba2a83e-56eb-486a-826e-7d0df5736466',
    'resources': 'REPLACE_AMSTERDAM_RESOURCES_DASHBOARD_ID'
  },

  'Madadeni': {
    'executive-summary': madadeni_dashboard_id,
    'operations-overview': '90c4c139-56bc-4208-a53c-9e267301c03f',
    'utilities': '5d7a6e32-7e99-44ab-8073-c52e6d529907',
    'energy': 'd508414a-53e1-49b5-949b-fa3f681503bb',
    'parking-access': 'REPLACE_MADADENI_PARKING_DASHBOARD_ID',
    'security': 'eeb55ea2-cbe2-44f7-b654-1748f61352ed',
    'connectivity': '18d66ce6-5ba0-424d-bb9e-1af669b3f326',
    'insights-analytics': '37ea32c7-0e6f-4f0b-a287-604ec2abee7c',
    'savings_insights': 'af3eec00-098b-467d-9070-cb74e404c25e',
    'profit-share': 'e3d9f46d-5be5-4307-a609-01c70b21eb55',
    'resources': 'REPLACE_MADADENI_RESOURCES_DASHBOARD_ID'
  },

  'Aliwal North': {
    'executive-summary': aliwal_north_dashboard_id,
    'operations-overview': 'b968075f-41c3-4b32-a4b6-320517051307',
    'utilities': '31ceafb5-e010-4828-992e-00c6ea20ab74',
    'energy': 'c2d58656-619c-40bb-8c33-cd8c6101c652',
    'parking-access': 'REPLACE_ALIWAL_NORTH_PARKING_DASHBOARD_ID',
    'security': '1a559cdd-ec8f-41d3-a1ae-cc126e2b1cb7',
    'connectivity': '0b680e61-fc4e-4904-aaca-07df4e5fbc8f',
    'insights-analytics': 'feb3672b-e493-450a-a468-ee37b48bcd55',
    'savings_insights': '977c8c92-95e1-4b62-bd5c-d70e34a51fed',
    'resources': 'REPLACE_ALIWAL_NORTH_RESOURCES_DASHBOARD_ID'
  },

  'Rustenburg': {
    'executive-summary': rustenburg_dashboard_id,
    'operations-overview': '5ebafd9c-aa19-4591-8e51-5f1115a37c96',
    'utilities': 'cce4eb29-97e9-4d70-8a7a-872f67deb18e',
    'energy': '343478c9-5b8a-4b69-9d63-e8c6f8726f63',
    'parking-access': 'REPLACE_RUSTENBURG_PARKING_DASHBOARD_ID',
    'security': 'ce822ed9-1a59-4651-92ad-466da6ce1d91',
    'connectivity': 'ad7008ca-0c35-4e2e-8094-572a8d94e74e',
    'insights-analytics': '0c2a86dd-10eb-402b-82d8-55d6996a9788',
    'savings_insights': 'd5c04b47-6932-4de1-952f-390f8af8566e',
    'resources': 'REPLACE_RUSTENBURG_RESOURCES_DASHBOARD_ID'
  },

  'Ngqamakhwe': {
    'executive-summary': ngqamakhwe_dashboard_id,
    'operations-overview': 'REPLACE_NGQAMAKHWE_OPERATIONS_DASHBOARD_ID',
    'utilities-energy': 'REPLACE_NGQAMAKHWE_UTILITIES_DASHBOARD_ID',
    'parking-access': 'REPLACE_NGQAMAKHWE_PARKING_DASHBOARD_ID',
    'security-it': 'REPLACE_NGQAMAKHWE_SECURITY_DASHBOARD_ID',
    'insights-analytics': 'REPLACE_NGQAMAKHWE_ANALYTICS_DASHBOARD_ID',
    'savings_insights': 'REPLACE_NGQAMAKHWE_SAVINGS_INSIGHTS_DASHBOARD_ID',
    'resources': 'REPLACE_NGQAMAKHWE_RESOURCES_DASHBOARD_ID'
  },

  'Mkhondo (Piet Retief)': {
    'executive-summary': mkhondo_dashboard_id,
    'operations-overview': 'dbf351a3-c322-4056-88a6-51319a947ccd',
    'utilities': '7404b879-acb7-4e3d-94e1-98ac03bc9396',
    'energy': '98ed236d-d547-4c29-894b-730908fd05fd',
    'parking-access': 'REPLACE_MKHONDO_PARKING_DASHBOARD_ID',
    'security': 'eea93215-5a04-4fb5-b4ea-1bc1552136f8',
    'connectivity': 'ad9c4b8d-65a8-4835-abbd-f88faf282363',
    'insights-analytics': '52b62e1f-39d0-4feb-9ed5-da777b19ea5b',
    'savings_insights': '4b3ea4ed-4758-45ca-bfc7-4b559305aae3',
    'resources': 'REPLACE_MKHONDO_RESOURCES_DASHBOARD_ID'
  }
};

// A fallback mapping used in the dashboard component
export const property_dashboards = {
  'executive-summary': null,
  'operations-overview': property_operations_dashboard_id,
  'utilities': property_utilities_dashboard_id,
  'energy': property_utilities_dashboard_id,
  'parking-access': property_parking_dashboard_id,
  'security': property_security_dashboard_id,
  'connectivity': property_security_dashboard_id,
  'insights-analytics': property_analytics_dashboard_id,
  'savings_insights': property_savings_insights_dashboard_id,
  'turnover': global_turnover_dashboard_id,
  'resources': property_resources_dashboard_id
};

// You can export a single default object if preferred by other modules:
export default {
  main_dashboard_id,
  erica_dashboard_id,
  lesedi_dashboard_id,
  thembokwezi_dashboard_id,
  ekuphumleni_dashboard_id,
  ganyesa_dashboard_id,
  amsterdam_dashboard_id,
  madadeni_dashboard_id,
  aliwal_north_dashboard_id,
  rustenburg_dashboard_id,
  ngqamakhwe_dashboard_id,
  mkhondo_dashboard_id,
  global_executive_dashboard_id,
  global_financial_dashboard_id,
  global_comparisons_dashboard_id,
  global_esg_dashboard_id,
  global_fungi_profit_share_id,
  global_risk_intelligence_dashboard_id,
  global_turnover_dashboard_id,
  mining_dashboards,
  property_operations_dashboard_id,
  property_utilities_dashboard_id,
  property_parking_dashboard_id,
  property_security_dashboard_id,
  property_analytics_dashboard_id,
  property_resources_dashboard_id,
  property_savings_insights_dashboard_id,
  property_specific_dashboards,
  property_dashboards
};
